/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsBasketballIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports-basketball"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.2 10.65Q1.35 9.4 1.77 8.3Q2.2 7.2 2.85 6.22Q3.73 7.08 4.3 8.22Q4.88 9.38 5.08 10.65ZM18.93 10.65Q19.13 9.38 19.7 8.24Q20.27 7.1 21.15 6.22Q21.8 7.2 22.23 8.3Q22.65 9.4 22.8 10.65ZM2.85 17.77Q2.2 16.8 1.77 15.7Q1.35 14.6 1.2 13.35L5.08 13.35Q4.88 14.63 4.3 15.76Q3.73 16.9 2.85 17.77ZM21.15 17.77Q20.27 16.9 19.7 15.76Q19.13 14.63 18.93 13.35L22.8 13.35Q22.65 14.6 22.23 15.7Q21.8 16.8 21.15 17.77ZM7.85 10.65Q7.6 8.7 6.74 7.06Q5.88 5.42 4.53 4.15Q5.75 2.95 7.3 2.2Q8.85 1.45 10.65 1.2L10.65 10.65ZM13.35 10.65L13.35 1.2Q15.15 1.45 16.7 2.2Q18.25 2.95 19.48 4.15Q18.13 5.42 17.26 7.06Q16.4 8.7 16.15 10.65ZM10.65 22.8Q8.85 22.55 7.3 21.8Q5.75 21.05 4.53 19.85Q5.88 18.57 6.74 16.94Q7.6 15.3 7.85 13.35L10.65 13.35ZM13.35 22.8L13.35 13.35L16.15 13.35Q16.4 15.3 17.26 16.94Q18.13 18.57 19.48 19.85Q18.25 21.05 16.7 21.8Q15.15 22.55 13.35 22.8Z" fill={color} />
    </svg>
  );
}
